/* eslint-disable react/jsx-props-no-spreading */
import type * as React from 'react';
import { JOB_MANUSCRIPT_TYPE } from '@doda/common/src/constants/jobManuscriptType';
import type { JobSearchResultResponse } from '@doda/api-client/aspida/@types';
import { JobCardA } from './components/JobCardA';
import { JobCardBC } from './components/JobCardBC';
import { JobCardDE } from './components/JobCardDE';
import { JobCardNoPic } from './components/JobCardNoPic';
import type { ApplyEventHandler } from './components/ApplyButton';
import type { FavoriteProps } from './components/FavoriteButton';

export type NavigateHandler = React.MouseEventHandler<HTMLAnchorElement>;

/**
 *ナビゲーションイベントのハンドラー
 */
interface JobCardEventHandlers {
  /** 直接応募求人への応募時 */
  onApplyDirect?: ApplyEventHandler;
  /** エージェントサービス求人への応募時 */
  onApplyAgent?: ApplyEventHandler;
  /** 詳細画面遷移時(タイトル) */
  onNavigateTitle?: NavigateHandler;
  /** 詳細画面遷移時(画像) */
  onNavigateImage?: NavigateHandler;
  /** 詳細画面遷移時(「求人詳細を見る」ボタン) */
  onNavigateFooterButton?: NavigateHandler;
  /** 気になるクリック時 */
  onBookmark?: FavoriteProps['onClickFavorite'];
  /** 気になるリスト遷移時 */
  onNavigateToBookmarkList?: FavoriteProps['onClickSaved'];
}

/**
 *類似キーワードエリアタイプ
 */
export interface SimilarKeywordAreaType {
  /** 検索キーワード */
  searchKeywords: string[] | undefined;
  /** 類似キーワード取得APIレスポンス */
  similarKeywordList: string[] | undefined;
}

/**
 *求人カード
 */
export interface JobCardBaseProps extends JobCardEventHandlers {
  /** 求人データ */
  job: JobSearchResultResponse;
  /** 遷移先のURL */
  destinationURL: string;
  /**
   * 画像の優先度を指定する
   *
   * trueの場合遅延読み込みしない
   */
  imagePriority?: boolean;
  /** 検索結果一覧で「気になるリストへ」を押下した際の追加パラメーター */
  bookmarkUrlQuery?: string | undefined;
  /** 検索結果一覧画面用 類似キーワードエリア */
  similarKeywordArea?: SimilarKeywordAreaType | undefined;
}

/**
 *求人カードの画像有無
 */
export interface JobCardProps extends JobCardBaseProps {
  /** 画像無し表示かどうか */
  isNoPic: boolean;
}

/**
 * Job Cardコンポーネント
 * @param {JobCardProps} props - JobCardコンポーネントのプロパティ
 * @returns {JSX.Element} レンダリングされたコンポーネント
 */
export const JobCard = ({ isNoPic, job, ...baseProps }: JobCardProps) => {
  if (isNoPic) return <JobCardNoPic job={job} {...baseProps} />;

  switch (job.jobManuscriptType) {
    case JOB_MANUSCRIPT_TYPE.typeD:
    case JOB_MANUSCRIPT_TYPE.typeE:
      return <JobCardDE job={job} {...baseProps} />;
    case JOB_MANUSCRIPT_TYPE.typeB:
    case JOB_MANUSCRIPT_TYPE.typeC:
      return <JobCardBC job={job} {...baseProps} />;
    case JOB_MANUSCRIPT_TYPE.typeA:
      return <JobCardA job={job} {...baseProps} />;
    default:
      return <JobCardNoPic job={job} {...baseProps} shouldDisplayAsCardTypeT />;
  }
};
